/* eslint-disable max-lines */
/* eslint-disable react/jsx-max-depth */
import { Button, Card, Group, Skeleton } from '@mantine/core';
import dompurify from 'dompurify';
import parse from 'html-react-parser';
import PropTypes from 'prop-types';
import React, { useContext, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import IcEdit from '../../components/icons/IcEdit';
import IcVisibility from '../../components/icons/IcVisibility';
import { AppContext } from '../../contexts';
import { fetchTermCondition } from './actions';
import styles from './styles.scoped.css';
import BreadcrumbLink from '../../components/elements/BreadcrumbLink/BreadcrumbLink';

export default function TermConditionContent({ type }) {
  const dispatch = useDispatch();
  const { setBreadcrumbs } = useContext(AppContext);
  const navigate = useNavigate();

  const {
    dataTermCondition,
    isLoadingTermCondition,
  } = useSelector((s) => s.termCondition);

  const data = dataTermCondition;
  const isLoading = isLoadingTermCondition;

  useEffect(() => {
    const formattedTabName = type.charAt(0).toUpperCase() + type.slice(1);

    const handleManajemenKebijakanClick = () => {
      // TBD: adjust the search param based on the type
      const searchParam = '?tab=subpangkalan';
      // const searchParam = isPangkalan ? '' : '?tab=subpangkalan';
      navigate(`/term-condition${searchParam}`);
    };

    setBreadcrumbs([
      <BreadcrumbLink key="manajemen-kebijakan" onClick={handleManajemenKebijakanClick} text="Manajemen Kebijakan" />,
      formattedTabName
    ]);

    const queryParam = new URLSearchParams(location.search);
    const tabParam = queryParam.get('tab');
    dispatch(fetchTermCondition(tabParam || 'pangkalan'));
  }, [dispatch, type, setBreadcrumbs, history]);

  const handleView = (item) => {
    const userType = type;
    const agreementId = item.id;
    const historyId = item.historyId;

    navigate({
      pathname: `/term-condition/preview/${userType}`,
      search: `?agreementId=${agreementId}&historyId=${historyId}`,
    });
  };

  const handleEdit = (item) => {
    const editPath = `/term-condition/update`;
    navigate({
      pathname: editPath,
      search: `?agreementId=${item.id}&historyId=${item.historyId}&userType=${type}`,
      state: {
        initialData: item,
        userType: type
      }
    });
  };

  const formatDate = (dateString) => {
    if (!dateString) return '';
    const date = new Date(dateString);
    return date.toLocaleDateString('id-ID', {
      year: 'numeric',
      month: 'short',
      day: 'numeric'
    });
  };

  const getStatusColor = (isActive) => {
    return isActive ? '#0F6EB5' : '#CF212A';
  };

  const getRequiredColor = (isRequired) => {
    return isRequired ? '#0F6EB5' : '#FF711A';
  };

  if (isLoading) {
    return (
      <div style={{ display: 'flex', flexDirection: 'column', gap: '40px' }}>
        <React.Fragment>
          <div className={styles.topContainer}>
            <div className={styles.filter}>
              <Skeleton height={24} width={100} />
            </div>
          </div>
          <Card mb={40} padding="md" sx={{ border: '1px solid #D9DEE4', borderRadius: '5px' }}>
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
              <div style={{ flex: 1 }}>
                <Skeleton height={24} mb={12} width="60%" />
                <Skeleton height={16} mb={8} width="100%" />
                <Skeleton height={16} width="80%" />
              </div>
              <Group ml={16} spacing="md">
                <Skeleton height={40} width={40} />
                <Skeleton height={40} width={40} />
              </Group>
            </div>
          </Card>
        </React.Fragment>
      </div>
    );
  }

  const renderTermConditionItems = () => {

    if (Array.isArray(data)) {
      return data.map((categoryGroup, categoryIndex) => (
        <React.Fragment key={`category-${categoryIndex}`}>
          <div className={styles.topContainer}>
            <div className={styles.filter}>
              <label className={styles.label}>
                {categoryGroup.category === 'SnK' ? 'S&K' : categoryGroup.category || 'Syarat & Ketentuan'}
              </label>
            </div>
          </div>

          {Array.isArray(categoryGroup.dataList) && categoryGroup.dataList.map((item, index) => (
            <Card
              key={`item-${item.id || index}`}
              mb={40}
              padding="md"
              sx={{ border: '1px solid #D9DEE4', borderRadius: '5px' }}
            >
              <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                <div style={{ flex: 1 }}>
                  <p style={{
                    marginBottom: '8px',
                    fontWeight: 600,
                    fontSize: '16px',
                    lineHeight: '24px',
                    letterSpacing: '-0.5%',
                    color: '#25282B'
                  }}><strong>{item.title}</strong></p>
                  <p style={{
                    display: '-webkit-box',
                    overflow: 'hidden',
                    textAlign: 'justify',
                    WebkitBoxOrient: 'vertical',
                    WebkitLineClamp: 2,
                    marginTop: 0,
                    marginBottom: 0,
                    color: '#52575C',
                    fontWeight: 400,
                    fontSize: '14px',
                    lineHeight: '21px',
                    letterSpacing: '0px'
                  }}>
                    {parse(dompurify.sanitize(item.content || ''))}
                  </p>
                  <div style={{
                    display: 'flex',
                    marginTop: '8px',
                    alignItems: 'center',
                    minHeight: '32px',
                    fontWeight: 400,
                    fontSize: '14px',
                    color: '#52575C'
                  }}>
                    <div style={{
                      display: 'flex',
                      alignItems: 'center',
                      padding: '4px 8px 4px 0',
                    }}>
                      <span style={{ fontWeight: 400 }}>Versi:</span>
                      <span style={{ marginLeft: '4px' }}>{item.version || '-'}</span>
                    </div>

                    <div style={{
                      width: '1px',
                      backgroundColor: '#52575C',
                      alignSelf: 'stretch',
                      margin: '2px 8px'
                    }} />

                    <div style={{
                      display: 'flex',
                      alignItems: 'center',
                      padding: '4px 8px',
                    }}>
                      <span style={{ fontWeight: 400 }}>{formatDate(item.createdAt)}</span>
                    </div>

                    <div style={{
                      width: '1px',
                      backgroundColor: '#52575C',
                      alignSelf: 'stretch',
                      margin: '2px 8px'
                    }} />

                    <div style={{
                      display: 'flex',
                      alignItems: 'center',
                      padding: '4px 8px',
                    }}>
                      <span style={{ fontWeight: 400 }}>Status:</span>
                      <span style={{
                        marginLeft: '4px',
                        fontWeight: 700,
                        color: getStatusColor(item.isEnabled || item.isEnable)
                      }}>
                        {(item.isEnabled || item.isEnable) ? 'Aktif' : 'Tidak Aktif'}
                      </span>
                    </div>

                    <div style={{
                      width: '1px',
                      backgroundColor: '#52575C',
                      alignSelf: 'stretch',
                      margin: '2px 8px'
                    }} />

                    <div style={{
                      display: 'flex',
                      alignItems: 'center',
                      padding: '4px 8px',
                    }}>
                      <span style={{ fontWeight: 400 }}>Jenis Persetujuan:</span>
                      <span style={{
                        marginLeft: '4px',
                        fontWeight: 700,
                        color: getRequiredColor(item.isRequired)
                      }}>
                        {item.isRequired ? 'Wajib' : 'Tidak Wajib'}
                      </span>
                    </div>
                  </div>
                </div>
                <Group ml={16} spacing="md">
                  <Button
                    onClick={() => handleView({ ...item, category: categoryGroup.category })}
                    p={8}
                    sx={{ width: 40, backgroundColor: 'var(--primary-color)' }}
                    type="primary"
                    variant="filled"
                  >
                    <IcVisibility />
                  </Button>
                  <Button
                    onClick={() => handleEdit({ ...item, category: categoryGroup.category })}
                    p={8}
                    sx={{ width: 40, backgroundColor: 'var(--primary-color)' }}
                    variant="filled"
                  >
                    <IcEdit />
                  </Button>
                </Group>
              </div>
            </Card>
          ))}
        </React.Fragment>
      ));
    } else if (data?.id) {

      return (
        <React.Fragment>
          <div className={styles.topContainer}>
            <div className={styles.filter}>
              <label className={styles.label}>{data.category || 'Syarat & Ketentuan'}</label>
            </div>
          </div>
          <Card mb={40} padding="md" sx={{ border: '1px solid #D9DEE4', borderRadius: '5px' }}>
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
              <div style={{ flex: 1 }}>
                <p style={{
                  marginBottom: 0,
                  fontWeight: 600,
                  fontSize: '16px',
                  lineHeight: '24px',
                  letterSpacing: '-0.5%',
                  color: '#25282B'
                }}><strong>{data.title}</strong></p>
                <p style={{
                  display: '-webkit-box',
                  overflow: 'hidden',
                  textAlign: 'justify',
                  WebkitBoxOrient: 'vertical',
                  WebkitLineClamp: 2,
                  marginTop: 0,
                  color: '#52575C',
                  fontWeight: 400,
                  fontSize: '14px',
                  lineHeight: '21px',
                  letterSpacing: '0px'
                }}>
                  {parse(dompurify.sanitize(data.content || ''))}
                </p>
                <div style={{
                  display: 'flex',
                  marginTop: '12px',
                  alignItems: 'center',
                  minHeight: '32px',
                  fontWeight: 500,
                  fontSize: '14px',
                  color: '#52575C'
                }}>
                  <div style={{
                    display: 'flex',
                    alignItems: 'center',
                    padding: '4px 8px 4px 0',
                  }}>
                    <span style={{ fontWeight: 500 }}>Versi:</span>
                    <span style={{ marginLeft: '4px', fontWeight: 700 }}>{data.version || '-'}</span>
                  </div>

                  <div style={{
                    width: '1px',
                    backgroundColor: '#D9DEE4',
                    alignSelf: 'stretch',
                    margin: '0 12px'
                  }} />

                  <div style={{
                    display: 'flex',
                    alignItems: 'center',
                    padding: '4px 8px',
                  }}>
                    <span style={{ fontWeight: 500 }}>{formatDate(data.createdAt)}</span>
                  </div>

                  <div style={{
                    width: '1px',
                    backgroundColor: '#D9DEE4',
                    alignSelf: 'stretch',
                    margin: '0 12px'
                  }} />

                  <div style={{
                    display: 'flex',
                    alignItems: 'center',
                    padding: '4px 8px',
                  }}>
                    <span style={{ fontWeight: 500 }}>Status:</span>
                    <span style={{
                      marginLeft: '4px',
                      fontWeight: 700,
                      color: getStatusColor(data.isEnabled || data.isEnable)
                    }}>
                      {(data.isEnabled || data.isEnable) ? 'Aktif' : 'Tidak Aktif'}
                    </span>
                  </div>

                  <div style={{
                    width: '1px',
                    backgroundColor: '#D9DEE4',
                    alignSelf: 'stretch',
                    margin: '0 12px'
                  }} />

                  <div style={{
                    display: 'flex',
                    alignItems: 'center',
                    padding: '4px 8px',
                  }}>
                    <span style={{ fontWeight: 500 }}>Jenis Persetujuan:</span>
                    <span style={{
                      marginLeft: '4px',
                      fontWeight: 700,
                      color: getRequiredColor(data.isRequired)
                    }}>
                      {data.isRequired ? 'Wajib' : 'Tidak Wajib'}
                    </span>
                  </div>
                </div>
              </div>
              <Group ml={16} spacing="md">
                <Button onClick={() => handleView(data)} p={8} sx={{ width: 40, backgroundColor: 'var(--primary-color)' }} type="primary" variant="filled">
                  <IcVisibility />
                </Button>
                <Button onClick={() => handleEdit(data)} p={8} sx={{ width: 40, backgroundColor: 'var(--primary-color)' }} variant="filled">
                  <IcEdit />
                </Button>
              </Group>
            </div>
          </Card>
        </React.Fragment>
      );
    }

    return null;
  };

  return (
    <div style={{ display: 'flex', flexDirection: 'column' }}>
      {renderTermConditionItems()}
    </div>
  );
}

TermConditionContent.propTypes = {
  type: PropTypes.string.isRequired
};
